import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { baseSidebarElement } from './baseSidebarElement';
// @deprecated Sidebar has been removed and Sidebar links will follow soon. See https://checkout.atlassian.net/browse/DASH-2788
const SidebarLink = styled(NavLink) `
  ${baseSidebarElement}
`;
export default SidebarLink;
